<template>
    <div class="keyfeatures-item">
        <div v-if="featureItem.img" class="keyfeatures-icon mb-spc42">
            <img :src="featureItem.img" alt="Key Features">
        </div>
        <div v-if="featureItem.content || featureItem.title" class="keyfeatures-item-content">
            <h2 v-if="featureItem.title" class="font-opensans text-xl font-bold leading-spc7 mb-spc41">
                {{featureItem.title}}
            </h2>
            <p v-if="featureItem.content" class="text-base opacity-50 font-normal leading-6">
                {{featureItem.content}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "KeyFeatureItemsDesktop",
        props: ['featureItem']
    }
</script>

<style scoped>

</style>